var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "drop-line",
    on: {
      mousedown: function ($event) {
        $event.stopPropagation()
        return _vm.startDrag.apply(null, arguments)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }